import ChargesList from './ChargesList';

export default ChargesList;
